import config from '../../../../config/config';

export const downloadMembershipCard = () => {
  window.open(config.downloadMembershipCardLink, '_blank');
};
